<template lang="pug">
  b2b-login-form-generic(
    :css='css',
    :logo='logo'
    :backImg='backImg'
    :next='next'
    :localproject='localproject',
    :logomenu='logomenu' )
</template>
<script>
import B2bLoginFormGeneric from '@/components/logingeneric/B2bLoginFormGeneric'

export default {
  name: 'login-form-ree',
  data () {
    return {
      css: 'ree.css',
      logo: 'ree.png',
      backImg: 'reeBack.jpg',
      next: '/ree/new-password-form',
      localproject: 'redelectrica',
      logomenu: 'ree.svg'
    }
  },
  components: {
    B2bLoginFormGeneric
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .ods-input, .ods-input__inner {
    background-color: #f0f8ff!important;
    color: #f0f8ff!important;
    border: 1px solid #003C6E;
  }
  ::v-deep .ods-button__custom {
    background-color: #003C6E!important;
  }
    ::v-deep .ods-p-0 {
    color: #003C6E!important;
  }

  ::v-deep .ods-button__custom:active,
  ::v-deep .ods-button__custom:hover,
  ::v-deep .ods-button__custom:focus{
    background-color: #748e9b!important;
  }
  ::v-deep .ods-p-0:active,
  ::v-deep .ods-p-0:hover,
  ::v-deep .ods-p-0:focus{

    color: #748e9b!important;
  }
  .login-form__title {
    color: #003C6E!important;
  }
  .login-form {
    padding-top: 6%;
    margin-right: 12%;
  }
  ::v-deep .ods-button.ods-p-32 {
    color: #003C6E!important;
  }
  ::v-deep  .ods-form-item__content.contrat {
    font-size: rem(12);
    margin-top: 10px;
  }
  ::v-deep .ods-form-item__content.contrat p {
    padding-bottom: 5px;
  }
  ::v-deep  .ods-form-item__content.info {
    font-size: rem(12);
    margin-top: 10px;
    color: #003C6E!important;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-align: justify;
  }
  ::v-deep .ods-form-item__content.into p {
    padding-bottom: 5px;
  }
  ::v-deep .bold {
    font-weight: bold;
}

  ::v-deep .login-form__actions.contrat {
        margin-bottom: 10px;
  }

</style>
